module.exports = __webpack_public_path__ + "img/Triathlon.3fc9eb11.png";